import basicController from "servicestack/basic.controller.properties";
import labels from "emun.customer/_labels";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import AutoQuery from 'servicestack/auto-query/auto-query.es6'
import orderConfig from "emun.order/order.config";
import cartConfig from "emun.cart/cart.config";
import resolve from "ioc/resolve";

export default class HardcodePromptController {
	constructor() {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
    $ctrl.labels = labels;
		$ctrl.bus
			.send("QueryVendors.json?OrderBy=Label&Take=1000")
			.then(function(res) {
        $ctrl.vendors = res.data.results;
        if ($ctrl.retailerId) {
          $ctrl.bus.send("QueryRetailers.json?Id=" + $ctrl.retailerId).then(res => {
            if (res.data.results.length) {
              $ctrl.retailer = res.data.results[0];
              $ctrl.selectRetailer();
            }
          })
        }
      });

    $ctrl.bus
      .send("QuerySalesRepList.json?Active=1&OrderBy=name")
      .then(function (res) {
        $ctrl.reps = res.data.results;
      });

    $ctrl.bus
      .send("QueryPaymentTerms.json")
      .then(function (res) {
        $ctrl.terms = res.data.results;
      });

    $ctrl.bus
      .send("QueryRepGroups.json")
      .then(function (res) {
        $ctrl.repGroups = res.data.results;
      });



	}

  loadHardcodes() {
    const $ctrl = this;
    $ctrl.hardCodes = [];
    console.debug("BL*** location", $ctrl.location);
    $ctrl.vendors.map(v => {
      $ctrl.hardCodes.push({
        retailerId: $ctrl.retailer.id,
        shipId: $ctrl.location ? $ctrl.location : undefined,
        vendorId: v.id,
        vendorLabel: v.label,
        repGroupId: "",
        paymentTerms: "",
        vendorCustId: "",
        vendorShipId: ""
      });
    });
    var url = $ctrl.location ? "QueryRetailerVendorLocations.json" : "QueryRetailerVendors.json";
    $ctrl.bus.send(url, {
      RetailerId: $ctrl.retailer.id,
      ShipId: $ctrl.location ? $ctrl.location : undefined
    }).then(res => {
      $ctrl.hardCodes.map(h => {
          res.data.results.map(r => {
            if ($ctrl.location) {
              if (r.retailerId == h.retailerId && r.shipId == h.shipId && r.vendorId == h.vendorId) {
                h.salesRepId = r.salesRepId;
                h.vendorCustId = r.vendorCustId;
                h.vendorShipId = r.vendorShipId;
                h.paymentTerms = r.paymentTerms;
                h.repGroupId = r.repGroupId;
              }
            } else {
              if (r.retailerId == h.retailerId && r.vendorId == h.vendorId) {
                h.salesRepId = r.salesRepId;
                h.vendorCustId = r.vendorCustId;
                h.paymentTerms = r.paymentTerms;
                h.repGroupId = r.repGroupId;
              }
            }
          });
      });
    });
  }

  changeShippingLocation() {
    const $ctrl = this;
    $ctrl.loadHardcodes();
  }

	findRetailers(val) {
		const $ctrl = this;
		var search = encodeURIComponent(val);
		let url = `QueryRetailers.json?Take=25&fields=${orderConfig.retailerSearchFields}&Status=Active&Search=${search}&OrderBy=CompanyName`; //
		return $ctrl.bus
		  .send(url, {
			op: "OrderHeaderFieldset",
		}).then((res) =>
        res.data.results.map((retailer) =>
          Object.assign(retailer, { config: cartConfig })
        )
      );
	}

	selectRetailer() {
		const $ctrl = this;
    $ctrl.loadHardcodes();
    $ctrl.bus
      .send("QueryRetailerShippingLocations.json?retailerid=" +
        $ctrl.retailer.id)
      .then(function (res) {
        $ctrl.locations = res.data.results;
    });
	}

	selectRepGroup() {
		const $ctrl = this;
    $ctrl.bus.send("QueryVendors.json?Active=1&OrderBy=Label", {
      RepGroupName: $ctrl.repGroup 
    }).then(res => {
      $ctrl.vendors = res.data.results;
      $ctrl.loadHardcodes();
    });
	}

  // loadVendors() {
  //   const $ctrl = this;
  //   $ctrl.bus.send("QueryVendors.json?Active=1&OrderBy=Label", {
  //     RepGroupName: $ctrl.repGroup,
  //     LabelContains: $ctrl.vendorSearch 
  //   }).then(res => {
  //     $ctrl.vendors = res.data.results;
  //     $ctrl.loadHardcodes();
  //   });
  // }

  clearReps() {
    const $ctrl = this;
		return modals
			.confirm("Are you sure you want to clear reps?", "Clear Reps?")
			.result.then(function () {
        $ctrl.hardCodes.map(h => h.salesRepId = "");
			});
  }
  setRepAll(repId) {
    const $ctrl = this;
		return modals
			.confirm("Assign Rep to all vendors?", "Assign Rep?")
			.result.then(function () {
        $ctrl.hardCodes.map(h => h.salesRepId = repId);
			});
  }

	submit() {
    const $ctrl = this;
    var url = $ctrl.location ? "ImportRetailerVendorLocations.json" : "ImportRetailerVendors.json";
    $ctrl.bus.send(url, {
      items: $ctrl.hardCodes
    }).then(res => {
      let $rootScope = resolve("$rootScope");
      $rootScope.$broadcast("hardcodeSaved", $ctrl.retailer.id );
      $ctrl.$dismiss();
    });    
	}
}
